/* src/app/modules/auth/pages/alert/alert.component.scss */
.message {
  white-space: pre-line;
}
/*# sourceMappingURL=alert.component-SYELXKWW.css.map */
